<script lang="ts">
	import { beforeNavigate } from '$app/navigation';
	import { getStepper, setStepper } from './stepper';
	setStepper();
	const stepper = getStepper();

	$: firstStepData = $stepper.steps?.[0]?.data;
	$: hasFilledData = Object.keys(firstStepData || {}).some(
		(key) => key !== '_alreadyChanged' && firstStepData[key] !== ''
	);

	beforeNavigate(({ cancel }) => {
		/*if (hasFilledData && !confirm('Está prestes a sair do simulador. Deseja continuar?')) {
			cancel();
		}*/
	});
</script>

<section class="h-full">
	<slot {stepper} />
</section>
